module.exports = __webpack_public_path__ + "media/images/lb/198-14bd8001b109f4006f8a24b18d105951.svg";